import React, { useState, useRef, useEffect } from 'react';
import { Flex, Text, Box } from 'rebass';
import * as Yup from 'yup';
// import { FiDownload } from "react-icons/fi";
import { FaInfoCircle } from "react-icons/fa";

import { ErrorMessageWrap, Label, TextFieldWrap } from 'app/form/formik/text/styled';
import { label } from 'babys-first-year/Step3';
import GiftCertificateStyle from './GiftCertificateStyle';

export const TextInput = React.forwardRef(({ error, showTextArea = false, value, onChange, subText, title, defaultValue, placeholder, onBlur, ...props }, ref) => {
    return <TextFieldWrap  {...props} my={2} error={!!error} sx={{
        borderColor: '#D9D9D9',
        borderRadius: '31px'
    }} >
        <Label fontSize={18}>{title}</Label>
        {showTextArea ? <textarea
            ref={ref}
            placeholder={placeholder}
            value={value}
            rows="5"
            defaultValue={defaultValue}
            onChange={onChange}
            onBlur={onBlur}
            autoComplete="off"
            style={{ width: '100%', fontColor: '#5E5E5E', lineHeight: '150%', letterSpacing: '0.108px', fontFamily: 'Poppins', fontSize: 16, minHeight: 100, padding: '10px', borderRadius: 31, resize: 'both', }}
        /> : <input
            ref={ref}
            placeholder={placeholder}
            value={value}
            defaultValue={defaultValue}
            onChange={onChange}
            onBlur={onBlur}
            autoComplete="off"
            style={{ width: '100%', fontColor: '#0E0E0E', lineHeight: '10px', letterSpacing: '0.108px', fontSize: 16, height: 42, padding: '10px', borderRadius: 31 }}
        />}
        {subText && <Flex mt="4px">
            <Text as={FaInfoCircle} color="#5E5E5E" size={14} minWidth={14} />
            <Text
                ml={1}
                sx={{
                    color: '#5E5E5E',
                    fontFeatureSettings: "'liga' off, 'calt' off",
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: '400',
                    lineHeight: '16px',
                }}
            >{subText}</Text>
        </Flex>}
        {error && (
            <ErrorMessageWrap maxWidth={290} fontSize={16}>
                {error}
            </ErrorMessageWrap>
        )}
    </TextFieldWrap >
})

const DesignGiftCertificate = React.forwardRef(({ email, setEmail,
    name_of_recipient,
    setNameOfRecipient,
    name_of_giver,
    setNameOfGiver,
    setGiftCertificateStyleId,
    gift_certificate_style_id,
    setShowError,
    showError,
}, ref) => {
    const [error, setError] = useState(showError || {})
    const contentRef = useRef(null);
    useEffect(() => {
        setError(showError || {})
    }, [showError])
    // const handlePrint = useReactToPrint({ contentRef, preserveAfterPrint: true });
    return <Flex flexDirection="column" >
        <TextInput
            title={label(<Text as="span" fontFamily="Poppins" fontSize={15} letterSpacing="-0.3px" >
                Parent Name(s)? :</Text>, true)
            }
            subText={"This will be printed on the certificate"}
            ref={ref}
            placeholder="Enter gift receiver’s name"
            defaultValue={name_of_recipient}
            error={error?.name_of_recipient}
            value={name_of_recipient}
            onChange={e => setNameOfRecipient(e.target.value)}
            onBlur={(e) => {
                Yup.object().shape({
                    name_of_recipient: Yup.string().required('Name of recipient is required'),
                }).validate({ name_of_recipient: e.target.value })
                    .then(() => {
                        setError({});
                        setNameOfRecipient(e.target.value)
                    })
                    .catch((err) => {
                        setError({ ...error, name_of_recipient: err.errors });
                    });
            }}
        />
        <TextInput
            title={label(<Text as="span" fontFamily="Poppins" fontSize={15} letterSpacing="-0.3px">
                Your Name(s)?</Text>, true)
            }
            placeholder="Enter your name(s)"
            subText={"This will be printed on the certificate"}         // defaultValue={name_of_giver}
            error={error?.name_of_giver}
            value={name_of_giver}
            onChange={e => setNameOfGiver(e.target.value)}
            onBlur={(e) => {
                Yup.object().shape({
                    name_of_giver: Yup.string().required('Name of giver is required'),
                }).validate({ name_of_giver: e.target.value })
                    .then(() => {
                        setError({});
                        setNameOfGiver(e.target.value)
                    })
                    .catch((err) => {
                        setError({ ...error, name_of_giver: err.errors });
                    });
            }}
        />
        {/* <TextInput
            title={label(<Text as="span" fontFamily="Poppins" fontSize={15} letterSpacing="-0.3px">
                Your email address?
            </Text>, true)
            }
            subText={"We email you the certificate to print or forward. Check your spam if not received."}
            placeholder="Your email"
            defaultValue={email}
            error={error?.email}
            onBlur={(e) => {
                schema
                    .validate({ email: e.target.value })
                    .then(() => {
                        setShowError(null)
                        setError({});
                        setEmail(e.target.value)
                    })
                    .catch((err) => {
                        setError({ ...error, email: err.errors });
                    });
            }}
        /> */}
        <Box mt={2} />
        <GiftCertificateStyle
            setGiftCertificateStyleId={setGiftCertificateStyleId}
            name_of_recipient={name_of_recipient}
            name_of_giver={name_of_giver}
            gift_certificate_style_id={gift_certificate_style_id}
            ref={contentRef}
        />

        {/* <Flex ml={"auto"} width="max-content" p={1} color='#9B59B6' justifyContent="left" alignItems="center" mb={'20px'} onClick={handlePrint} sx={{ cursor: 'pointer' }}>
            <FiDownload color='#9B59B6' />
            <Text ml={1}>
                Download Draft
            </Text>
        </Flex> */}
    </Flex >
})

export default DesignGiftCertificate;